import React from "react";
import { useTemplate, Templates } from "@/util-react/template";
import {FixBenefitsDefault} from "@/elements-react/fix-benefits/templates/fix-benefits.default.tsx";
import {FixBenefitsBlackAndBlue} from "@/elements-react/fix-benefits/templates/fix-benefits.black-and-blue.tsx";

export interface FixBenefitsProps {
    className?: string;
}

const templates: Record<Templates, React.ComponentType<FixBenefitsProps>> = {
    [Templates.DEFAULT]: FixBenefitsDefault,
    [Templates.BLACK_AND_BLUE]:  FixBenefitsBlackAndBlue,
};

export const FixBenefits: React.FC<FixBenefitsProps> = (props: FixBenefitsProps) => {
    const template = useTemplate();
    const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

    return <TemplatedComponent {...props} />;
};
